import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { MemberService } from 'src/app/member/services/member-service';
import { PagesModels } from 'src/app/pages';
import { ClientService } from 'src/app/client/services/client-service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { FundType } from 'src/app/client/types';
import { getBenefitList } from 'src/app/pages/state/pages.selectors';
import * as PageAction from '../../../state/pages.actions';
import { BenefitItem } from 'src/app/pages/models/page.model';
import { MemberBenefitDataModel, PayeeProfileRequest } from 'src/app/member/models';

@Component({
  selector: 'psrs-payee-profile',
  templateUrl: './payee-profile.component.html',
  styleUrls: ['./payee-profile.component.scss']
})
export class PayeeProfileComponent implements OnInit, OnDestroy {
  readonly FundType = FundType;
  private _page: PagesModels.PageDefinition
  unsubscribe$ = new Subject<void>()
  subs: Subscription = new Subscription()
  @Input() set page (value: PagesModels.PageDefinition) {
    this._page = value
  }

  get page (): PagesModels.PageDefinition {
    return this._page
  }

  TEMPLATE_KEY: any = {
    SupportContact: 'supportContact',
    PayeeProfile: 'payeeProfile'
  };
  loading = true;
  fundType: FundType;
  public benefits: BenefitItem[] = [];
  selectedBenefit?: BenefitItem;
  memberId: string;
  memberBenefitData: MemberBenefitDataModel;

  constructor(
    private memberService: MemberService,
    private store:Store,
  ) {
  }

  ngOnInit(): void {
    this.fundType = parseInt(localStorage.getItem('fundType'));
    this.memberId = localStorage.getItem('memberId');
    if (this.fundType !== FundType.ChicagoLabor) {
      this.store.dispatch(PageAction.getBenefitList());
      this.getBenefitList();
    }
  }

  getBenefitList() {
    this.store.select(getBenefitList).pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(el => {
      if (el && el.headerBenefits?.length) {
        this.benefits = el.headerBenefits;
        this.selectedBenefit = this.benefits[0];
        this.getDataFollowBenefit();
      } else {
        this.benefits = [];
        this.loading = false;
      }
    });
  }

  getDataFollowBenefit() {
    const queryParams: PayeeProfileRequest = {
      memberId: this.memberId,
      benefitEntityId: this.selectedBenefit.benefitEntityId,
      benefitId: this.selectedBenefit.benefitEntityDataId,
    };
    this.memberService.getPayeeProfile(queryParams)
    .subscribe(data => {
      if(data){
        this.loading = false;
        this.memberBenefitData = data.memberBenefitData;
      }
    });
  }
  
  benefitOnChange(event: any) {
    this.selectedBenefit = this.benefits.find(el => el.benefitId === event.target.value);
    this.loading = true;
    this.getDataFollowBenefit()
  }

  ngOnDestroy (): void {
    this.unsubscribe$.next()
    this.unsubscribe$.complete()
  }
}
